import { CardSkeleton } from '@/components/shared/skeleton'

const ContentSkeleton = () => (
  <div className="flex h-full flex-col justify-between">
    <CardSkeleton className="h-[532px] w-full sm:h-[384px]" />

    <div className="flex gap-10 pb-40 pt-24 sm:pb-32">
      <CardSkeleton className="h-[96px] w-full" />
      <CardSkeleton className="h-[96px] w-full" />
      <CardSkeleton className="h-[96px] w-full" />
    </div>
  </div>
)

export default ContentSkeleton
